var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c(
            "el-dialog",
            {
              staticClass: "articleModal",
              attrs: {
                visible: _vm.visible,
                title: (_vm.formType == 1 ? "订单" : "") + "发货",
                top: "100px",
                width: "740px",
                "destroy-on-close": "",
                modal: false,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "整单发货", name: "1" },
                  }),
                  _vm._v(" "),
                  _c("el-tab-pane", {
                    attrs: { label: "拆单发货", name: "2" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeName == 1
                ? _c(
                    "el-form",
                    { ref: "pram", attrs: { "label-width": "100px" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "物流设置：",
                            prop: "interfaceTemplate",
                          },
                        },
                        [
                          _vm._l(_vm.sendLists, function (item, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "flex",
                                staticStyle: { "margin-bottom": "15px" },
                              },
                              [
                                _c("SendCompany", {
                                  attrs: { showCompany: _vm.showCompany },
                                  model: {
                                    value: _vm.sendLists[i],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.sendLists, i, $$v)
                                    },
                                    expression: "sendLists[i]",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml10",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeCompany(i)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                loading: _vm.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sendLists.push({
                                    transportNo: null,
                                    companyValue: null,
                                  })
                                },
                              },
                            },
                            [_vm._v("新增物流")]
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeName == 2
                ? [
                    _c("SkuSend", {
                      ref: "skuSendRef",
                      attrs: {
                        itemLists: _vm.itemLists,
                        sendLists: _vm.sendLists,
                      },
                      on: {
                        "submit-disabled-change":
                          _vm.handleSplitSubmitDisabledChange,
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        disabled: _vm.submitDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handerSubmit("pram")
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }